import React from 'react';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import PropTypes from 'prop-types';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { useSelector } from 'react-redux';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';

export const FeedbackModal = ({
  isOpen,
  isClosed,
  title,
  isShowSubscribeModal,
}) => {
  const dsUserInfo = useSelector((state) => {
    return state.GET_DS_USER_INFO;
  });
  const { navigate } = useRouter();
  const isConnected =
    dsUserInfo?.data?.status === 'ACTIVE' ||
    dsUserInfo?.data?.status === 'PENDING' ||
    dsUserInfo?.data?.status === 'DENIED';
  const modalClose = () => {
    isClosed(false);
  };

  return (
    <Modal
      title={title}
      isOpen={isOpen}
      closeOnClickOutside={false}
      onClose={() => {
        return modalClose();
      }}
      css={{
        'abyss-modal-header-container': {
          color: '#002677',
          fontSize: '28.83px',
        },
        'abyss-modal-content-title': {
          fontSize: '26px !important',
        },
      }}
    >
      <Modal.Section>
        <Layout.Group alignLayout="right">
          <Button
            id="submitButton"
            size="$md"
            css={{
              'abyss-button-root': {
                fontSize: '15px',
              },
            }}
            onClick={() => {
              return modalClose();
            }}
          >
            Yes, it was helpful
          </Button>

          <Button
            variant="outline"
            id="closeButton"
            size="$md"
            css={{
              'abyss-button-root': {
                fontSize: '15px',
              },
            }}
            onClick={() => {
              modalClose();
              if (!isConnected) {
                navigate('/welcome/intake');
                return;
              }
              isShowSubscribeModal(true);
            }}
          >
            No, I think I need more help
          </Button>
        </Layout.Group>
      </Modal.Section>
    </Modal>
  );
};
FeedbackModal.propTypes = {
  isClosed: PropTypes.func.isRequired,
  isShowSubscribeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
